import { render, staticRenderFns } from "./one-video.vue?vue&type=template&id=140528c8&"
import script from "./one-video.vue?vue&type=script&lang=js&"
export * from "./one-video.vue?vue&type=script&lang=js&"
import style0 from "./one-video.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports